import { TranslateService } from '@ngx-translate/core';
import { Option } from 'src/app/settings/model/value-field';

// Poniżej tego progu cała lista i tak mieści się w panelu bez przewijania, więc pole "szukaj"
// tylko zabierałoby miejsce.
export const OPTION_SEARCH_THRESHOLD = 8;

/**
 * Klucz pozycji "bez wartości" na liście filtra kolumnowego (np. "Bez uchybień"). Nie jest wartością
 * z danych - ColumnFilterService zdejmuje go z listy i zamienia na RequestCriteria.includeEmpty.
 */
export const EMPTY_VALUE_OPTION_KEY = '__empty__';

/**
 * Tekst, po którym szuka się w liście wartości filtra kolumnowego. Opcje bywają HTML-em (np.
 * kolorowe znaczniki uchybień) albo kluczem tłumaczenia, więc szukajka musi widzieć to samo, co
 * widzi użytkownik.
 */
export function buildOptionSearchIndex(options: Option[], translate: TranslateService): Map<any, string> {
  return new Map((options ?? []).map(option => {
    const text = option.isHtml ? option.value?.replace(/<[^>]*>/g, ' ') : translate.instant(option.value);
    return [option.key, (text ?? '').toString().toLowerCase()] as [any, string];
  }));
}
